import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';

import styles from './Signout.module.scss';
import { useTheme } from '../../../../../ThemeContext';

type Props = {
  panelClassName?: string;
  panelHeaderClassName?: string;
  logoutYes: () => void;
  cancelLogout: string;
};

const Signout = ({ panelClassName, panelHeaderClassName, logoutYes, cancelLogout }: Props): JSX.Element => {
  const { t } = useTranslation('common');
  const { universalStyles } = useTheme();
  return (
    <>
      <section className={panelClassName}>
        <div className={panelHeaderClassName} style={universalStyles.primaryTextColor}>
          <h2>{t('sign_out')}</h2>
        </div>
        <p className={styles.content} style={universalStyles.inActiveColor}>
          {t('sign_out_content')}
        </p>
        <div className={styles.buttonBar}>
          <span>
            <Button onClick={logoutYes} size="exlarge" variant="signoutYes" label={t('yes')} />
          </span>
          <span>
            <Button to={cancelLogout} color="primary" size="exlarge" variant="signoutNo" label={t('no')} />
          </span>
        </div>
      </section>
    </>
  );
};

export default Signout;
